export default __webpack_public_path__ + "static/media/8.a0715f67.jpg";